/**
 * O3 (Salon Owner localization & polish) — the owner-portal string modules,
 * merged on top of LanguageContext's inline dictionary. One module per area so
 * parallel work never edits the same file; a key defined in two modules is a bug
 * (caught by i18n/owner/ownerStrings.test.ts).
 */
import type { OwnerStrings } from './types';
import { myBusinessStrings } from './myBusiness';
import { staffSettingsStrings } from './staffSettings';
import { shellStrings } from './shell';
import { statusStrings } from './status';
import { staffStrings } from './staff';
import { dashboardStrings } from './dashboard';

export const OWNER_STRING_MODULES: Record<string, OwnerStrings> = {
    dashboard: dashboardStrings,
    myBusiness: myBusinessStrings,
    staffSettings: staffSettingsStrings,
    shell: shellStrings,
    status: statusStrings,
    staff: staffStrings,
};

export function mergedOwnerStrings(lang: 'en' | 'ar'): Record<string, string> {
    return Object.values(OWNER_STRING_MODULES).reduce<Record<string, string>>(
        (acc, mod) => Object.assign(acc, mod[lang]),
        {},
    );
}
